import { RateCardResponse } from "../types/rateCard";
import { api } from "./api";

class RateCardService {
  async getPricingZones(userId: number | string) {
    const { data } = await api.get<RateCardResponse>(
      `/rate-card/pricing-zones/${userId}`
    );
    return data;
  }
}

export const rateCardService = new RateCardService();
